import { ApiRoutes } from '../apiRoutes';
import { brPost } from '../brRequestWrapper';
import { UpdateInvoiceCollectionStatusRequest } from '../../utils/invoiceUtils/invoiceTypes';

export const updateBillingReminderFeedback = (
  invoices: UpdateInvoiceCollectionStatusRequest[]
) => brPost(ApiRoutes.UpdateBulkInvoiceCollectionStatus, invoices);
